import jwtDecode from 'jwt-decode'

// this should be an api call but for now we just hard code
const PAGE_PERMISSIONS = {
  '/review-requests': [
    'SuperAdmin',
    'Admin',
    'Manager',
    'ReviewTech'
  ],
  '/admin': [
    'SuperAdmin',
    'Admin'
  ],
  '/admin/import-data': [
    'SuperAdmin',
    'Admin'
  ],
  '/admin/usps/check': [
    'SuperAdmin',
    'Admin'
  ],
  '/admin/usps/process': [
    'SuperAdmin',
    'Admin'
  ],
  '/dashboard': [
    'SuperAdmin',
    'Admin',
    'Manager'
  ],
  '/admin/config': [
    'SuperAdmin',
    'Admin',
    'Manager'
  ],
  '/admin/video': [
    'SuperAdmin',
    'Admin',
    'Manager'
  ],
  '/admin/teams': [
    'SuperAdmin',
    'Admin',
    'Manager'
  ],
  '/admin/businesses': [
    'SuperAdmin',
    'Admin',
    'Manager'
  ],
  '/admin/devices': [
    'SuperAdmin',
    'Admin',
    'Manager'
  ],
  '/work-orders': [
    'SuperAdmin',
    'Admin',
    'Manager',
    'Dispatch',
    'LeadTech',
    'InShopTech',
    'DiagCoord',
    'MasterTech'
  ],
  '/work-order': [
    'SuperAdmin',
    'Admin',
    'Manager',
    'Dispatch',
    'LeadTech',
    'InShopTech',
    'DiagCoord',
    'MasterTech'
  ],
  '/work-order-submit': [
    'SuperAdmin',
    'Admin'
  ]
}

export default {
  token: state => state.token,
  passthrough: state => state.passthrough,
  user: state => state.token ? jwtDecode(state.token) : {},
  isAllowed: (state) => {
    return (page = '') => {
      if (!PAGE_PERMISSIONS[page]) {
        return true
      }
      if (state.roles && state.roles.length) {
        return state.roles.some(r => PAGE_PERMISSIONS[page].includes(r))
      }
      return PAGE_PERMISSIONS[page].includes('Guest')
    }
  },
  userProfile: state => state.userProfile,
  roles: state => state.roles,
  // primaryRole: state => state.primaryRole,
  primaryRole: (state) => {
    let _role = ''
    for (let role of state.roles) {
      if (role === 'InShopTech' || role === 'DiagCoord') {
        _role = 'Tech'
        break
      } else if (role === 'MasterTech') {
        _role = 'MasterTech'
        break
      } else if (role === 'ReviewTech') {
        _role = 'ReviewTech'
        break
      } else if (role === 'Dispatch') {
        _role = 'Dispatch'
        break
      } else if (role === 'LeadTech') {
        _role = 'LeadTech'
        break
      } else if (role === 'SuperAdmin') {
        _role = 'SuperAdmin'
        break
      } else if (role === 'Admin') {
        _role = 'Admin'
        break
      } else if (role === 'Leadership') {
        _role = 'Leadership'
        break
      } else if (role === 'Manager') {
        _role = 'Manager'
        break
      } else if (role === 'Shop Admin') {
        _role = 'Shop Admin'
        break
      } else if (role === 'Shop User') {
        _role = 'Shop User'
        break
      } else if (role === 'Mobile') {
        _role = 'Mobile'
        break
      }
    }
    return _role
  },
  phoneNumber: state => state.phoneNumber,
  phoneExtension: state => state.phoneExtension
}



// WEBPACK FOOTER //
// ./src/store/modules/auth/getters.js